import { symbols } from '../constants';
function YAxis(_) {
    return null;
}
YAxis.defaultProps = {
    show: true,
    type: 'value',
    splitLine: true
};
YAxis[symbols.typeKey] = symbols.yAxis;
if (process.env.NODE_ENV !== 'production') {
    YAxis.displayName = 'YAxis';
}
export default YAxis;
//# sourceMappingURL=YAxis.js.map